import React from 'react';
import { Segment, Card } from 'semantic-ui-react';
import HospitalCard from './Cards/HospitalCard';
import getFilteredHospitals from '../../../functions/getFilteredHospitals';

const HospitalList = ({ changeMapCenter, filterValue, location = { lat: 0, lng: 0 } }) => {
  const hospitals = getFilteredHospitals(filterValue, location);
  return (
    <Segment className="Hospitals__SideBar__List">
      <Card.Group className="Hospitals__SideBar__List__Cards">
        {hospitals.map((hospital) => {
          return (
            <HospitalCard
              key={hospital.id}
              hospital={hospital}
              changeMapCenter={changeMapCenter}
              location={location}
              hasImage
              hasSector
              hasRouteButton
              hasFindButton
            />
          );
        })}
      </Card.Group>
    </Segment>
  );
};

export default HospitalList;



// WEBPACK FOOTER //
// ./src/components/Hospitals/SubComponents/HospitalList.js